import { useQuery } from "@tanstack/react-query";
import { useAdminSession } from "@/hooks/useAdminSession";
import { listAllProcesses, type ListAllProcessesParams } from "./dian-processes";

export function useAdminDianProcesses(params: ListAllProcessesParams) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "dian-processes", params],
    enabled,
    queryFn: () => listAllProcesses(params),
  });
}